import React from "react";
import { Outlet } from "react-router-dom";
import ScrollToTop from "@/components/ScrollToTop";
import CustomGlobalLoading from "@/components/GlobalLoading";
import { useOpenAIPixel } from "@/hooks/useOpenAIPixel";

const RootLayout = () => {
    useOpenAIPixel();

    return (
        <ScrollToTop>
            <CustomGlobalLoading />
            <Outlet />
        </ScrollToTop>
    );
};

export default RootLayout;
